import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@repo/shopify/locales/en";
import jp from "@repo/shopify/locales/jp";
import ko from "@repo/shopify/locales/ko";

import { DOMAIN, PREVIEW_DOMAIN } from "@const/urls";

const lang = localStorage.getItem("i18nextLng");
let newLang = "ko";

if (window.location.href.includes("localhost") || window.location.hostname.includes("ngrok")) {
  newLang = lang ? lang : newLang;
} else {
  if (window.location.href.includes(DOMAIN.ko) || window.location.href.includes(PREVIEW_DOMAIN.ko)) {
    newLang = "ko";
  }

  if (window.location.href.includes(DOMAIN.en) || window.location.href.includes(PREVIEW_DOMAIN.en)) {
    newLang = "en";
  }

  if (window.location.href.includes(DOMAIN.jp) || window.location.href.includes(PREVIEW_DOMAIN.jp)) {
    newLang = "jp";
  }
}

const STORE_HOST = (DOMAIN[newLang as keyof typeof DOMAIN] ?? DOMAIN.ko).replace(/^https?:\/\//, "").replace(/\/$/, "");

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: newLang,
    fallbackLng: ["ko", "en"],
    detection: {
      order: ["subdomain"],
      lookupFromSubdomainIndex: 0,
    },
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        storeName: "thisisneverthat®",
        storeDomain: STORE_HOST,
        supportEmail: "info@thisisneverthat.com",
        serviceEmail: newLang === "ko" ? "service@thisisneverthat.com" : "intl@thisisneverthat.com",
        channelTalkDomain: newLang === "ko" ? "thisisneverthat.channel.io" : "thisisneverthat-intl.channel.io",
      },
    },
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      jp: { translation: jp },
    },
    react: { useSuspense: true },
  });

export default i18n;
